(function () {
  var root = document.documentElement;
  var animationMs = 200;
  var initialized = false;
  var lastX = 0;
  var lastY = 0;
  var replayButton = document.getElementById("disabled-demo-replay");
  var countButton = document.getElementById("disabled-demo-count");
  var statusNode = document.getElementById("disabled-demo-status");

  function isDisabledElement(element) {
    return !!(element && (element.disabled || element.classList.contains("disabled")));
  }

  function hasDisabledTargets() {
    return !!document.querySelector(".disabled, input:disabled, textarea:disabled, select:disabled, button:disabled");
  }

  function getDisabledTargets() {
    return Array.prototype.slice.call(
      document.querySelectorAll(".disabled, input:disabled, textarea:disabled, select:disabled, button:disabled")
    );
  }

  function setStatus(text) {
    if (!statusNode) return;
    statusNode.textContent = "Status: " + text;
  }

  function isPointInRect(x, y, rect) {
    return x >= rect.left && x <= rect.right && y >= rect.top && y <= rect.bottom;
  }

  function findDisabledAtPoint(x, y) {
    var disabledTargets = document.querySelectorAll(".disabled, input:disabled, textarea:disabled, select:disabled, button:disabled");
    var found = null;

    for (var i = 0; i < disabledTargets.length; i++) {
      var element = disabledTargets[i];
      var rect = element.getBoundingClientRect();
      if (isPointInRect(x, y, rect)) {
        found = element;
      }
    }

    return found;
  }

  function flashDisabledAnimation(element) {
    if (!element) return;

    var targets = [];
    var wrappedDisabledLabel = element.closest("label.disabled");
    var labels;
    var i;

    function pushAnimatedTarget(target) {
      if (!target) return;
      if (targets.indexOf(target) > -1) return;
      targets.push(target);
    }

    function getLabelControl(label) {
      if (!label) return null;
      if (label.htmlFor) {
        return document.getElementById(label.htmlFor);
      }
      return label.querySelector("input, textarea, select, button");
    }

    // If a disabled input is wrapped by a disabled label, animate only the label.
    if (element.tagName && element.tagName.toLowerCase() === "label") {
      // Label clicks always animate label + associated control.
      var resolvedControl = getLabelControl(element);
      pushAnimatedTarget(element);
      // Avoid double-transform when the control is nested inside the label.
      if (!(resolvedControl && element.contains(resolvedControl))) {
        pushAnimatedTarget(resolvedControl);
      }
    } else if (wrappedDisabledLabel) {
      pushAnimatedTarget(wrappedDisabledLabel);
    } else {
      // If clicking a "for" label, animate label + linked control.
      if (element.tagName && element.tagName.toLowerCase() === "label" && element.htmlFor) {
        pushAnimatedTarget(element);
        pushAnimatedTarget(document.getElementById(element.htmlFor));
      } else {
        // Otherwise animate target and any external labels linked to it.
        pushAnimatedTarget(element);
        if (element.id) {
          labels = document.querySelectorAll("label[for]");
          for (i = 0; i < labels.length; i++) {
            if (labels[i].htmlFor === element.id) {
              pushAnimatedTarget(labels[i]);
            }
          }
        }
      }
    }

    for (var j = 0; j < targets.length; j++) {
      var target = targets[j];
      if (!isDisabledElement(target)) continue;

      target.classList.add("show-disabled-animation");
      (function (el) {
        setTimeout(function () {
          el.classList.remove("show-disabled-animation");
        }, animationMs);
      })(target);
    }
  }

  function replayDisabledAnimation() {
    var targets = getDisabledTargets();
    for (var i = 0; i < targets.length; i++) {
      flashDisabledAnimation(targets[i]);
    }
    setStatus("Replayed animation for " + targets.length + " disabled target(s) (inputs + labels).");
  }

  function reportDisabledTargetCount() {
    var count = getDisabledTargets().length;
    setStatus(count + " disabled target(s) found on this page (inputs + labels).");
  }

  function updateDisabledCursor() {
    var hoveredDisabled = findDisabledAtPoint(lastX, lastY);
    root.classList.toggle("show-disabled-cursor", !!hoveredDisabled);
  }

  function onMousemove(event) {
    lastX = event.clientX;
    lastY = event.clientY;
    updateDisabledCursor();
  }

  function onScroll() {
    updateDisabledCursor();
  }

  function onClick(event) {
    lastX = event.clientX;
    lastY = event.clientY;
    var clickedDisabled = findDisabledAtPoint(lastX, lastY);
    if (clickedDisabled) {
      flashDisabledAnimation(clickedDisabled);
    }
  }

  function initDisabledShake(force) {
    if (initialized) return;
    if (!force && !hasDisabledTargets()) return;

    initialized = true;
    document.addEventListener("mousemove", onMousemove, { passive: true });
    document.addEventListener("scroll", onScroll, { passive: true });
    document.addEventListener("click", onClick, false);
  }

  window.initDisabledShake = initDisabledShake;

  document.addEventListener("updateDisabledShake", function (event) {
    var shouldForce = !!(event && event.detail && event.detail.force);
    initDisabledShake(shouldForce);
  });

  if (replayButton) {
    replayButton.addEventListener("click", replayDisabledAnimation);
  }

  if (countButton) {
    countButton.addEventListener("click", reportDisabledTargetCount);
  }

  initDisabledShake(false);
  reportDisabledTargetCount();
})();
